import { render, staticRenderFns } from "./ChosenVehicle.vue?vue&type=template&id=1bb4f5d2&scoped=true&"
import script from "./ChosenVehicle.vue?vue&type=script&lang=js&"
export * from "./ChosenVehicle.vue?vue&type=script&lang=js&"
import style0 from "./ChosenVehicle.vue?vue&type=style&index=0&id=1bb4f5d2&scoped=true&lang=scss&"
import style1 from "./ChosenVehicle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb4f5d2",
  null
  
)

export default component.exports